import { Component, Injector, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StructureAssignmentConfig } from '../../../core/tokens';

@Component({
	selector: 'bp-project-structure-assignment',
	standalone: true,
	imports: [CommonModule],
	template: `
		@if (loading) {
			<div class="text-center py-2">
				<div class="spinner-border spinner-border-sm" role="status">
					<span class="visually-hidden">Laden...</span>
				</div>
				<span class="ms-2 small">Laden...</span>
			</div>
		} @else if (entities.length === 0) {
			<div class="text-muted small py-2">{{ config.emptyText ?? 'Keine Einträge vorhanden.' }}</div>
		} @else {
			<div class="list-group list-group-flush" style="max-height: 200px; overflow-y: auto;">
				@for (entity of entities; track entity._id) {
					<label class="list-group-item list-group-item-action py-1 px-2 d-flex align-items-center">
						<input type="checkbox" class="form-check-input me-2"
							[checked]="isSelected(entity._id)"
							(change)="toggle(entity._id)">
						@if (config.icon) {
							<i class="bi {{ config.icon }} me-1"></i>
						}
						<small>{{ entity[config.displayProperty] }}</small>
						@if (config.secondaryProperty && entity[config.secondaryProperty]) {
							<small class="text-muted ms-1">({{ entity[config.secondaryProperty] }})</small>
						}
					</label>
				}
			</div>
		}
	`
})
export class ProjectStructureAssignmentComponent implements OnInit {
	@Input() config!: StructureAssignmentConfig;
	@Input() project: any;

	private injector = inject(Injector);

	entities: any[] = [];
	loading = false;

	async ngOnInit(): Promise<void> {
		this.loading = true;
		try {
			const service = this.injector.get(this.config.serviceType);
			if (typeof service.getAllFromRemote === 'function') {
				this.entities = await service.getAllFromRemote();
			}
		} catch (err) {
			console.error(`[StructureAssignment] Fehler beim Laden (${this.config.label}):`, err);
		} finally {
			this.loading = false;
		}
	}

	isSelected(id: string): boolean {
		const ids: string[] = this.project?.[this.config.projectField] ?? [];
		return ids.includes(id);
	}

	toggle(id: string): void {
		if (!this.project) return;
		const field = this.config.projectField;
		if (!this.project[field]) {
			this.project[field] = [];
		}
		const ids: string[] = this.project[field];
		const index = ids.indexOf(id);
		if (index >= 0) {
			ids.splice(index, 1);
		} else {
			ids.push(id);
		}
	}
}
